import { createContext } from 'react';

export type NuveiCreditCardCtx = {
  showNuveiCreditCardSuccessAlert: boolean;
  showNuveiCreditCardErrorAlert: boolean;
  nuveiCreditCardError: string;
};

const NuveiCreditCardContext = createContext<NuveiCreditCardCtx>({
  showNuveiCreditCardSuccessAlert: false,
  showNuveiCreditCardErrorAlert: false,
  nuveiCreditCardError: '',
});

export default NuveiCreditCardContext;
